type ProductFruits =
  | {
      api?: {
        feedback?: { showModal: () => undefined };
        inAppCenter?: {
          isOpened?: () => boolean;
          open: () => void;
        };
      };
      feedback?: { shownPopupEl?: Element | null };
      services?: { destroy?: () => void };
    }
  | undefined;

function getProductFruits(): ProductFruits {
  return window.productFruits;
}

// oxlint-disable-next-line no-unused-vars
function openProductFruitsFeedbackModal(): void {
  getProductFruits()?.api?.feedback?.showModal();
}
export function openProductFruitsHelpCenterModal(): void {
  getProductFruits()?.api?.inAppCenter?.open();
}

export function isProductFruitsOpen(): boolean {
  try {
    const productFruits = getProductFruits();
    return (
      !!productFruits?.api?.inAppCenter?.isOpened?.() ||
      !!productFruits?.feedback?.shownPopupEl
    );
  } catch {
    return false;
  }
}

export function destroyProductFruits() {
  const productFruits = getProductFruits();
  if (productFruits?.services?.destroy) productFruits.services.destroy();
}
